import { render, staticRenderFns } from "./viewRes.vue?vue&type=template&id=76788481"
import script from "./viewRes.vue?vue&type=script&lang=js"
export * from "./viewRes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports